export const HISTORY_ADD = 'HISTORY_ADD'

export function historyAdd(commitMsg, commitHash, author, timestamp) {
    return {
        type: HISTORY_ADD,
        commitMsg, 
        commitHash,
        author,
        timestamp
    }
}